news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>에듀윌, 넥스트챌린지·넥스트챌린지스쿨과 MOU 체결</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                              <h2><span style="font-family:'맑은 고딕';"><strong>에듀윌,&nbsp;넥스트챌린지·넥스트챌린지스쿨과 MOU&nbsp;체결</strong></span>
                              </h2>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';"><strong>&nbsp;- AI&nbsp;교육 혁신 통해 미래 인재 양성…&nbsp;사회적 가치 창출</strong></span>
                              </p>
                              <p><span style="font-family:'맑은 고딕';"><strong>&nbsp;-&nbsp;‘에듀윌 동맹 100개 기업’ 연계로 스타트업과의 시너지 기대</strong></span>
                              </p>
                              <p>&nbsp;</p>
                              <p>&nbsp;</p>
                              <figure class="image"><img src="//company.eduwill.net/contents/img/20250605142206.jpg"></figure>
                              <p><span style="font-family:'맑은 고딕';">▲사진 설명:&nbsp;에듀윌 양형남 대표(좌측)와 넥스트챌린지 김영록 대표가 업무협약서에 서명하고,&nbsp;기념 촬영을 하고 있다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">(2025-05-09) 종합교육기업 에듀윌(대표 양형남)은 8일 넥스트챌린지(대표 김영록),&nbsp;넥스트챌린지스쿨과 함께 인공지능(AI)&nbsp;기반 미래인재 양성을 위한 업무협약(MOU)을 체결했다고 9일 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">이번 협약은 유망 스타트업을 육성하고 창업 생태계를 확산하기 위한 협력의 일환으로,&nbsp;세 기관은 다양한 교육 및 혁신 프로그램을 통해 상호 협력하기로 했다.&nbsp;협약식에는 에듀윌 양형남 대표,&nbsp;넥스트챌린지 김영록 대표,&nbsp;넥스트챌린지스쿨 최진교 교장을 비롯한 주요 관계자들이 참석했다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">넥스트챌린지는 국내 유일 베트남 재무부 국가혁신센터(NIC)&nbsp;내에 현지 법인을 두고 있으며,&nbsp;과기부 NSSC,&nbsp;문체부 VTConline&nbsp;국영기업, VIN University&nbsp;외 산학연관 현지 네트워크를 구축하고 있다.&nbsp;글로벌 기업과 협업을 통해 국내 스타트업의 글로벌 경쟁력 강화를 위한 다양한 지원 프로그램을 운영한다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">넥스트챌린지스쿨은 AI와 인간이 공존하는 유일한 학교이자,&nbsp;한국 최초로 글로벌 7개국을 탐방하는 스타트업 국제학교다.&nbsp;기술의 가치가 인간의 가치를 넘어서는 시대,&nbsp;넥스트챌린지스쿨은 특이점(Singularity)에 대한 미래 방향을 다음 세대에게 제시한다.&nbsp;</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">세 기관은 ▲청소년 대상 AI&nbsp;진로 및 창업 역량 강화 프로그램 공동 기획 및 운영 ▲성인 및 재직자 대상 AI&nbsp;리터러시 향상 및 직무 역량 강화 교육 ▲AI&nbsp;관련 직무교육 협업 ▲국내외 유망 스타트업 발굴 및 오픈이노베이션 연계 ▲스타트업 생태계 시너지 창출을 위한 공동 사업 추진 ▲에듀테크 및 미래 교육산업 선도를 위한 네트워크 구축 등 다양한 분야에서 협력할 계획이다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">에듀윌 양형남 대표는 “이번 협약은 AI&nbsp;기반 미래 인재 양성을 위한 교육 혁신을 넘어,&nbsp;에듀윌과 두 기관 간 전략적 파트너십을 통해 사회적 가치를 창출하는 출발점이 될 것”이라며,&nbsp;“에듀윌 동맹 100개 기업에 적합한 유망 스타트업과 연결하는데 넥스트챌린지가 함께 하고,&nbsp;넥스트챌린지스쿨과는 검정고시와 직무교육 등 다양한 분야에서 실질적인 협업 시너지를 창출할 수 있을 것으로 기대한다”고 밝혔다</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">넥스트챌린지 김영록 대표는 “청소년과 성인 모두에게 AI&nbsp;역량을 갖춘 창의적 인재로 성장할 수 있는 기회를 제공하겠다”고 밝혔다.</span>
                              </p>
                              <p>&nbsp;</p>
                              <p><span style="font-family:'맑은 고딕';">한편,&nbsp;이번 협약은 최근 에듀윌이 다양한 외부 기관 및 기업과 활발히 업무협약을 체결하고 있는 흐름과 맞닿아 있다.&nbsp;올해 에듀윌이 추진 중인 ‘메가 프로젝트’의 일환으로,&nbsp;핵심 전략인 공진화(共進化)&nbsp;즉,&nbsp;외부 파트너와의 상호 성장과 혁신을 통한 교육 생태계 확장에 기반하고 있다.&nbsp;</span>
                              </p>
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                                <li class="prev">
                                    <router-link to="/edu/newsRelease/promotionVideo/news23" data-value="315283">
                                        <strong>이전</strong>
                                        <span>에듀윌, 공인중개사 교재로 온라인서점 1위부터 22위까지 석권… ’수험서 시장 평정’</span>
                                    </router-link>
                                </li>

                                <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news21" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌×아이헤이트플라잉버그스, AI 기반 온택트 학습 MOU 체결</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
